import {useEffect, useState} from 'react';
import {IContainerApp} from '../../navigationButtonComponents/loansTab/containerApp/IContainerApp';
import {v4 as uuid} from 'uuid';
import InquiryFee from './fee/inquiryFee';
import ResultPayment from './resultPayment/resultPayment';
import InquiryOtp from './otp/inquiryOtp';
import {TInnerState} from './IInquriry';
import InquiryResult from './result/inquiryResult';
import {useDispatch, useSelector} from 'react-redux';
import {getpervStateTab} from '../../../redux/loansTab/loansTabSlice';
import {RootState} from '../../../redux/store';
import {
    TotalInquiryRequest,
    IInquiryResponse,
} from '../../../models/inquiry.model';
import {useMutation, useQueryClient} from 'react-query';
import {TotalInquiry} from '../../../services/inquiry.service';
import {INQUIRY_REQUIRED_OTP} from '../../../config/cacheKey';
import {
    changeRouteType,
    getpervInnerState,
} from '../../../redux/handleBackBtn/handleBackBtnSlice';
import {ApiResultModel} from '../../../models/common.model';
export default function WaitForInquiry({
    referenceKey,
    setStep,
    stepMain,
}: IContainerApp) {
    const [innerState, setInnerState] = useState<TInnerState>();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const randomKeyForDispatch = Math.random();
    const request = {} as TotalInquiryRequest;
    request.referenceKey = referenceKey!;
    const {mutateAsync: InquiryValidationOTPMutation, isLoading} = useMutation(
        TotalInquiry,
        {
            onSuccess: (data: ApiResultModel<IInquiryResponse>) => {
                if (data) {
                    if (data.data.requiredOtpValidation) {
                        setInnerState!('otp');
                        queryClient.setQueryData(
                            INQUIRY_REQUIRED_OTP,
                            data.data.requiredOtpValidation
                        );
                    } else if (data.data.inquiries.length > 0) {
                        setInnerState!('inquiryResult');
                        // queryClient.setQueryData(INQUIRY_RESULT, data.inquiryResult);
                    } else {
                        setStep(uuid);
                    }
                }
            },
            onError: () => {},
        }
    );
    useEffect(() => {
        if (stepMain === 'WaitForInquiryPayment') {
            setInnerState('fee');
        } else {
            InquiryValidationOTPMutation(request);
        }
        dispatch(changeRouteType({routeType: 'child'}));
        dispatch(
            getpervInnerState({
                prevInnerState: `inquiry ${randomKeyForDispatch}`,
            })
        );
    }, []);
    const stateFromRedux = useSelector(
        (state: RootState) => state.prevAndNextState.nextInnerState
    ) as TInnerState;
    useEffect(() => {
        if (stateFromRedux.includes('inquiry')) setInnerState('fee');
    }, [stateFromRedux]);
    const innerStep = {
        fee: (
            <InquiryFee
                setInnerState={setInnerState}
                setStep={setStep}
                referenceKey={referenceKey}
            />
        ),
        otp: (
            <InquiryOtp
                setInnerState={setInnerState}
                referenceKey={referenceKey}
            />
        ),
        payResult: (
            <ResultPayment
                setInnerState={setInnerState}
                setStep={setStep}
                referenceKey={referenceKey}
            />
        ),
        inquiryResult: (
            <InquiryResult
                referenceKey={referenceKey!}
                setInnerState={setInnerState}
                setStep={setStep}
                stepMain={stepMain}
            />
        ),
    };
    return <div>{innerStep[innerState!]}</div>;
}
